
import { defineComponent, PropType, ref } from "vue";
import { Heading3, Heading4, Paragraph, Note } from "@/components/layout";
import { AsideLine, BlockList } from "@/components/common";
import { PeriodDto } from "@/types";
import { useOnScrollTransition } from "@/hooks";

export default defineComponent({
  name: "Timeline",
  components: { AsideLine, BlockList, Heading3, Heading4, Paragraph, Note },
  props: {
    entities: {
      type: Array as PropType<PeriodDto[]>,
    },
  },
  setup() {
    const periods = ref([]);

    useOnScrollTransition(periods, "animate-scroll-top");

    return { periods };
  },
});
